/**
 * MODULE: _shared/frontend-shell/src/layout/ShellTopBarMetrics.tsx
 * PURPOSE: Measure shell TopBar height and expose --shell-topbar-height on :root for sticky offsets and drawers.
 * DEPENDENCIES: react (useLayoutEffect)
 * PUBLIC_API: ShellTopBarMetrics
 * SIDE_EFFECTS: Sets CSS custom property on documentElement
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 38 / 100 lines
 * RECENT: 2026-06-14 [2.2.1385] — Sets --shell-topbar-height on :root for drawer offsets.
 */

import { useLayoutEffect } from 'react';

const TOPBAR_SELECTOR = '[data-shell-app-topbar]';

export function ShellTopBarMetrics() {
  useLayoutEffect(() => {
    const bar = document.querySelector(TOPBAR_SELECTOR);
    if (!bar) return;

    const sync = () => {
      const height = Math.ceil(bar.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--shell-topbar-height', `${height}px`);
    };

    sync();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(sync) : null;
    ro?.observe(bar);
    window.addEventListener('resize', sync);

    return () => {
      ro?.disconnect();
      window.removeEventListener('resize', sync);
      document.documentElement.style.removeProperty('--shell-topbar-height');
    };
  }, []);

  return null;
}
